/** Picks the "สคริปต์แนะนำรายคน" backend: mock (default dev/screens mode) or the real API (same origin/session). */
import { useMock } from '../index'
import { HttpScriptApi } from './http'
import { MockScriptApi } from './mock'
import type { ScriptApi } from './types'

let current: ScriptApi | null = null

export function getScriptApi(): ScriptApi {
  if (!current) current = useMock ? new MockScriptApi() : new HttpScriptApi((import.meta.env.VITE_API_BASE ?? '').trim())
  return current
}

/** Tests inject their own backend. */
export function setScriptApi(api: ScriptApi | null): void {
  current = api
}

export type * from './types'
